import { render, staticRenderFns } from "./ErrorPages.vue?vue&type=template&id=37c69060&"
import script from "./ErrorPages.vue?vue&type=script&lang=js&"
export * from "./ErrorPages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports